import React from 'react';
import { Modal, Button } from 'antd';

const CreateOrgAlertModal = props => {
  const { isModalVisible } = props;
  return (
    <Modal
      title="Create an organization"
      visible={isModalVisible}
      onCancel={props.hideModal}
      width="465px"
      okText="Contact Support"
      onOk={props.contactCloudnosys}
    >
      <p style={{ fontSize: '15px', fontWeight: 500, marginTop: '-10px' }}>
        You are not allowed to create a new organization in this package. Please contact support.{' '}
      </p>
    </Modal>
  );
};

export default CreateOrgAlertModal;
